import { ShieldAlert } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { useLanguage } from "@/i18n/LanguageContext";

export default function HowToBuy() {
  const { t } = useLanguage();
  const steps = t("steps.list");
  return (
    <section id="how-to-buy" className="scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8" data-testid="how-to-buy-section">
      <div className="mx-auto max-w-7xl">
        <SectionHeader kicker={t("steps.kicker")} title={t("steps.title")} id="how-to-buy" />
        <ol className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {steps.map((s, i) => (
            <Reveal key={s.t} delay={0.05 * i}>
              <li
                data-testid={`how-to-buy-step-${i + 1}`}
                className="group relative h-full overflow-hidden rounded-xl border border-red-900/30 bg-[#140A0D] p-6 transition-colors hover:border-red-700/50"
              >
                <span
                  aria-hidden="true"
                  className="absolute -right-2 -top-4 font-display text-7xl font-black text-red-950/70 transition-colors duration-500 group-hover:text-red-900/70"
                >
                  {i + 1}
                </span>
                <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.3em] text-yellow-600">Step {i + 1}</p>
                <h3 className="relative mb-2 text-base font-bold text-zinc-100">{s.t}</h3>
                <p className="relative text-sm leading-relaxed text-zinc-400">{s.d}</p>
              </li>
            </Reveal>
          ))}
        </ol>

        <Reveal delay={0.15}>
          <div className="mt-10 flex gap-4 rounded-xl border border-red-700/50 bg-red-950/20 p-6 sm:p-8" data-testid="security-warning-box" role="alert">
            <ShieldAlert size={24} className="mt-0.5 shrink-0 text-red-500" aria-hidden="true" />
            <div>
              <h3 className="mb-1.5 text-base font-bold text-red-400">{t("steps.warnTitle")}</h3>
              <p className="text-sm leading-relaxed text-zinc-300">{t("steps.warnBody")}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
